export { default as stateToHTML } from './stateToHTML';


//////////////////
// WEBPACK FOOTER
// ../draft-js-export-html/esm/main.js
// module id = 2047
// module chunks = 22